export const NAME_MAX_LEN = 50;

// буквы любой раскладки, цифры, пробел, -, _ и ()
export const ALLOWED_RE = /^[\p{L}\p{N} _\-()]*$/u;

export const NAME_ERROR_CODES = {
  TOO_LONG: 'TOO_LONG',
  INVALID_CHARS: 'INVALID_CHARS',
  ONLY_SPACES: 'ONLY_SPACES',
};
